import React from 'react'

class ProfilePicture extends React.Component {

  onClick = () => {
    if (this.props.onClick) {
      this.props.onClick()
    }
  }

  render() {
    const className = this.props.className || "h-auto max-w-full rounded-md border bg-card p-1"
    let image_url

    if ((this.props.profile_picture || {}).thumbnail_url) {
      image_url = this.props.profile_picture.thumbnail_url
    }
    else {
      let index = (this.props.id || 0) % 16

      if (index === 0) {
        index = 1
      }

      image_url = `https://tm2-assets.ams3.cdn.digitaloceanspaces.com/images/shared/${index}.png`
    }

    let image_content

    if (this.props.width) {
      image_content = (
        <img src={image_url} className={className} width={this.props.width} title={this.props.title || ''} onClick={this.onClick}/>
      )
    }
    else {
      image_content = (
        <img src={image_url} className={className} style={{maxHeight: this.props.maxHeight || '100%'}} title={this.props.title || ''} onClick={this.onClick}/>
      )
    }

    if (this.props.profile_picture && this.props.clickable) {
      return (
        <a href={image_url} target="_blank">
          {image_content}
        </a>
      )
    }

    return image_content
  }
}

export default ProfilePicture
